<template>
  <div class="wrap1">
    <h1 class="common-title">
      <i class="el-icon-arrow-left icon" @click="handlerBack"></i>
      <span>{{ $t('payroll_salary_1') }}</span>
    </h1>
    <div class="wrap1-box wrap1-btn">
      <el-steps class="steps" v-if="arr.length" :active="active" finish-status="success" align-center>
        <el-step v-for="(item, index) in arr" :key="index" :title="item.value"></el-step>
      </el-steps>
      <component
        class="component"
        v-if="activeObj.comp"
        :is="activeObj.comp"
        :activeObj="activeObj"
        :ref="activeObj.name"
      ></component>
    </div>
    <el-row class="flex-btn">
      <el-button size="small" @click="prev" v-if="active > 0 && active <= arr.length - 1">
        {{ $t('422') }}
      </el-button>
      <el-button size="small" type="primary" @click="next" v-if="active != arr.length - 1">
        {{ $t('331') }}
      </el-button>
      <el-button size="small" type="primary" @click="save" v-else>
        {{ $t('67') }}
      </el-button>
    </el-row>
  </div>
</template>

<script>
import { get_tab } from 'api/payroll/salary-scheme/detail'
import tab1Attendance from './tab1-attendance'
import { tabPaneArr } from './conf'
import rdiff from 'recursive-diff'

export default {
  name: 'step2',
  components: {
    tab1Attendance
  },
  data() {
    return {
      arr: [],
      active: 0,
      activeObj: {},
      scheme_id: this.$route.params.id,
      isRoute: false
    }
  },
  mounted() {
    this.get_tab()
    this.preventBack()
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener('popstate', window.pushStateFun, false)
    const data = this.activeObj.data
    if (this.isRoute) {
      next()
    } else {
      const diff = rdiff.getDiff(data.cInfo, data.info)
      if (!diff.length) next()
      else {
        this.$confirm(this.$t('payroll_management_28'), this.$t('payroll_management_27'), {
          confirmButtonText: this.$t('submit_btn'),
          cancelButtonText: this.$t('cancel_btn'),
          type: 'warning'
        })
          .then(() => {
            next()
          })
          .catch(() => {})
      }
    }
  },
  methods: {
    preventBack() {
      const this_ = this
      window.pushStateFun = function () {
        const data = this_.activeObj.data
        const diff = rdiff.getDiff(data.cInfo, data.info)
        if (!diff.length) this_.handlerBack()
        else {
          this_
            .$confirm(this_.$t('payroll_management_28'), this_.$t('payroll_management_27'), {
              confirmButtonText: this_.$t('submit_btn'),
              cancelButtonText: this_.$t('cancel_btn'),
              type: 'warning'
            })
            .then(() => {
              this_.isRoute = true
              this_.handlerBack()
            })
            .catch(() => {
              const state = {
                title: null,
                url: document.UTL // 要禁掉的页面
              }
              /*
                  三个参数：
                  state：一个与指定网址相关的状态对象，popstate事件触发时，该对象会传入回调函数。如果不需要这个对象，此处可以填null。
                  title：新页面的标题，但是所有浏览器目前都忽略这个值，因此这里可以填null。
                  url：新的网址，必须与当前页面处在同一个域。浏览器的地址栏将显示这个网址。
                */
              window.history.pushState(state, null, document.UTL) // 要禁掉的页面
            })
        }
      }
      const state = {
        title: null,
        url: document.UTL // 要禁掉的页面
      }
      window.history.pushState(state, null, document.UTL) // 要禁掉的页面
      window.addEventListener('popstate', window.pushStateFun, false)
    },
    get_tab() {
      get_tab({ payroll_sub_project_scheme_id: this.scheme_id }).then(res => {
        if (res && res.code === 1) {
          this.arr = res.data.map(v => {
            const item = tabPaneArr.filter(v1 => v1.id === v.id)[0]
            return { ...v, ...item }
          })
          this.activeObj = this.arr[this.active]
        }
      })
    },
    async prev() {
      let res = {}
      try {
        res = await this.$refs[this.activeObj.name].saveData()
        if (!res) return
        this.active--
        this.activeObj = this.arr[this.active]
      } catch (e) {
        res = e
      }
    },
    async next() {
      let res = {}
      try {
        res = await this.$refs[this.activeObj.name].saveData()
        if (!res) return
        this.active++
        this.activeObj = this.arr[this.active]
      } catch (e) {
        res = e
      }
    },
    async save() {
      let res = {}
      try {
        res = await this.$refs[this.activeObj.name].saveData()
        this.$message.success(res.message)
        if (res.code === 1) {
          this.isRoute = true
          this.$router.push({
            path: '/payroll/salary-scheme'
          })
        }
      } catch {}
    },
    handlerBack() {
      this.$router.push({
        path: '/payroll/salary-scheme'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap1-box {
  /deep/ .steps {
    padding: 24px 0;
    border-bottom: 1px solid #f0f0f0;
    .el-step__head {
      &.is-success {
        color: #f0f0f0;
        border-color: #f0f0f0;
        border-width: 1px;
        .el-step__line {
          height: 1px;
          background: #f0f0f0;
        }
        .is-text {
          background: #fff;
          border-color: #5D51DA;
          .el-step__icon-inner {
            color: #5D51DA;
          }
        }
      }
      &.is-process,
      &.is-finish {
        .is-text {
          background: #5D51DA;
          border-color: #5D51DA;
        }
        .el-step__icon-inner {
          color: #fff;
        }
      }
    }
    .el-step__line {
      height: 1px;
      background: #f0f0f0;
    }
    .el-step__icon {
      width: 32px;
      height: 32px;
      border: 1px solid;
    }
    .el-step__main {
      .is-wait {
        font-size: 16px;
        color: #8c8c8c;
      }
      .is-finish {
        font-size: 16px;
        color: #262626;
      }
      .is-success {
        font-size: 16px;
        color: #595959;
      }
    }
  }
  .component {
    padding-top: 24px;
  }
}
</style>
